module.exports = __webpack_public_path__ + "static/media/Patient_Sign_Upload_Icon.3afc4ca6.svg";